import formatYearlyData from '@/functions/formatYearlyData';
import * as actions from '@/constants/actions';
import gql from 'graphql-tag';
import { apolloClient } from '@/apollo/apollo';

export default {
    mounted() {
        if (this.stationId === 0) return;
        this.getYearlyDataAvailable();
    },
    data() {
        return {
            /*
             * d for day
             * m for month
             */
            chartInterval: 'd',
            yearlyDataDisplay: [],
            yearlyDataAvailable: [],
            yearlyData: {},
            updateData: false,
        };
    },
    methods: {
        /**
         * format 365-day yearly data into 18-month chart datasets
         * @param {Function} formatDateDataFunc function to format date data
         * @param {Boolean} mss "true" if this is a Manual Snow Survey dataset, default false
         * @return {Array} formatted chart.js datasets
         */
        formatYearlyData(formatDateDataFunc, mss = false) {
            return formatYearlyData(
                this.yearlyData,
                this.yearlyDataDisplay,
                formatDateDataFunc,
                this.chartInterval,
                mss,
            );
        },
        /**
         * reset the yearly data
         */
        resetYearlyData() {
            this.yearlyDataDisplay = [];
            this.yearlyDataAvailable = [];
            this.yearlyData = {};
        },
        /**
         * query the API for precipitation data for one year
         * @param  {String}  year data year
         */
        async getYearlyData(year) {
            const loadingKey = `get yearly data ${year}`;
            this.$store.dispatch(actions.ADD_LOADING, loadingKey);
            try {
                const { data } = await apolloClient.query({
                    query: gql`query stationYearlyData($id: Int!, $year: Int!) {
                    getStation(id: $id) {
                        ${this.dataType}(year: $year) {
                            yearly
                        }
                    }
                }`,
                    variables: {
                        year,
                        id: this.stationId,
                    },
                });
                // store data in this component
                this.yearlyData[year] = data.getStation[this.dataType].yearly;
            } catch (ex) {
                this.$store.dispatch(actions.TRIGGER_TOAST, 'Error retrieving yearly station data');
            }
            this.$store.dispatch(actions.REMOVE_LOADING, loadingKey);
        },
        /**
         * run the needed queries for yearly data overlays
         */
        async addYearlyData() {
            // check which yearly data values are needed
            const haveData = Object.keys(this.yearlyData);
            const needData = this.yearlyDataDisplay.filter(e => !haveData.includes(e));

            // @TODO: use some async/await-friendly version of forEach?
            /* eslint-disable */
            for (let y of needData) {
                await this.getYearlyData(y);
            }
            /* eslint-enable */

            this.updateData = true;
        },
        async getYearlyDataAvailable() {
            const loadingKey = 'get yearly data available';
            this.$store.dispatch(actions.ADD_LOADING, loadingKey);
            try {
                const { data } = await apolloClient.query({
                    query: gql`query stationYearlyData($id: Int!) {
                    getStation(id: $id) {
                        historical_${this.dataType}_years
                    }
                }`,
                    variables: {
                        id: this.stationId,
                    },
                });
                // store data in this component
                this.yearlyDataAvailable = data.getStation[`historical_${this.dataType}_years`];
            } catch (ex) {
                this.$store.dispatch(actions.TRIGGER_TOAST, 'Error retrieving yearly station data');
            } finally {
                this.$store.dispatch(actions.REMOVE_LOADING, loadingKey);
            }
        },
    },
    computed: {
        /**
         * get the station id from VueX
         * @return {Number}
         */
        stationId() {
            const station = this.$store.state.map.selectedStation;
            if (station === null) {
                return 0;
            }
            return station.id;
        },
    },
    watch: {
        /**
         * add yearly data when years are selected
         */
        yearlyDataDisplay() {
            this.addYearlyData();
        },
        /**
         * add list of historical yearly station data on station change
         * @param {Number} stationId
         */
        stationId(stationId) {
            if (stationId === 0) return;
            this.getYearlyDataAvailable();
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/yearlyChart.js